/**
 * Représente les differents évènements émis par les composants WorkflowTriggerNodeComponent, WorkflowStepNodeComponent et WorkflowActionNodeComponent.
 */
export enum NodeEventTypes {
    /**
     * Le noeud a été selectionné.
     */
    Selected = 1,
    /**
     * Le noeud a été deselectionné.
     */
    Unselected = 2,
    /**
     * Une socket de sortie de changement d'état a été ajouté au noeud affichant une étape.
     */
    AddTriggerStepChanged = 3,
    /**
     * Une socket de sortie d'activation de l'étape a été ajouté au noeud affichant une étape.
     */
    AddTriggerActivated = 4,
    /**
     * Une socket de sortie de finalisation de l'étape a été ajouté au noeud affichant une étape.
     */
    AddTriggerCompleted = 5,
    /**
     * Une socket d'entrée de changement d'état a été ajouté au noeud affichant une étape.
     */
    AddActionChangeStep = 6,
    /**
     * Une socket d'entrée d'activation d'étape a été ajouté au noeud affichant une étape.
     */
    AddActionActivate = 7,
    /**
     * Une socket d'entrée de finalisation de l'étape a été ajouté au noeud affichant une étape.
     */
    AddActionComplete = 8,
    /**
     * Une socket d'entrée du noeud a été selectionnée.
     */
    InputSocketSelected = 9,
    /**
     * Une socket de sortie du noeud a été selectionnée.
     */
    OutputSocketSelected = 10,
}
